<div class="table-container trip-roster touch-scrollbar">
    <table class="table table-responsive trips dtrips">
        <thead #tableHeader>
            <tr class="frow">
                <th scope="col">Log ID #</th>
                <th scope="col">Date & Time</th>
                <th scope="col" style="opacity: 1; min-width: 180px">
                    <!-- <div class="dropdown broker-status-search">
                        <a
                            data-target="statusDropdown"
                            class="touch-border-frame tripsbtn"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <span class="dropdown-toggle">
                                <span class="light-weight">
                                    <ng-container *ngIf="!selectedStatusFilter">Status</ng-container>
                                    <ng-container *ngIf="selectedStatusFilter">{{ selectedStatusFilter | capitalizeWithSpaces }}</ng-container>
                                </span>
                                <span class="dropdown-search">
                                    <img class="dropdown-polygon mr-2" src="/assets/images/Polygon.svg" alt="" />
                                </span>
                            </span>
                        </a>
                        <div class="dropdown-menu cd-menu first card-shadow" aria-labelledby="statusDropdown">
                            <div class="dropdown-item cd-item cursor-pointer" (click)="selectStatusFilter(null)">All Statuses</div>
                            <div
                                class="dropdown-item cd-item cursor-pointer"
                                (click)="selectStatusFilter(statusOption)"
                                *ngFor="let statusOption of statusOptions"
                            >
                                {{ statusOption | capitalizeWithSpaces }}
                            </div>
                        </div>
                    </div> -->

                    <div class="dropdown">
                        <a
                            data-target="brokerDropdown"
                            class="tripsbtn dropdown-caret"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <span
                                class="dropdown-toggle text-dark-blue op-5 border border-2 br-6 py-1 px-3"
                                [ngClass]="{ 'fw-normal': !selectedStatusFilter }"
                            >
                                <span class="light-weight status-text" *ngIf="!selectedStatusFilter">All Statuses</span>
                                <span class="light-weight status-text" *ngIf="selectedStatusFilter">
                                    {{ selectedStatusFilter | capitalizeWithSpaces }}
                                </span>
                                <span class="dropdown-caret-icon"><span class="caret"></span></span>
                            </span>
                        </a>
                        <div class="dropdown-menu cd-menu status-filter-dropdown first card-shadow" aria-labelledby="brokerDropdown">
                            <div class="dropdown-item cd-item cursor-pointer" (click)="selectStatusFilter(null)">All Status</div>
                            <div
                                class="dropdown-item cd-item cursor-pointer"
                                (click)="selectStatusFilter(statusOption)"
                                *ngFor="let statusOption of statusOptions"
                            >
                                {{ statusOption | capitalizeWithSpaces }}
                            </div>
                        </div>
                    </div>

                    <!-- <div class="btn-group" dropdown>
                      <button
                          id="button-basic"
                          dropdownToggle
                          type="button"
                          class="btn btn-outline-secondary br-6 bg-white dropdown-toggle fs-13 fw-600 px-4 py-1"
                          aria-controls="dropdown-basic"
                      >
                          Status
                          <span class="caret"></span>
                      </button>
                      <ul
                          id="dropdown-basic"
                          *dropdownMenu
                          class="dropdown-menu cd-menu first card-shadow dropdown-menu-right"
                          role="menu"
                          aria-labelledby="button-basic"
                      >
                      <li role="menuitem">
                        <div
                            class="dropdown-item blue cd-item cursor-pointer"
                            (click)="selectStatusFilter(null)"
                        >
                          All Statuses
                        </div>
                      </li>
                        <li role="menuitem" *ngFor="let statusOption of statusOptions">
                          <div
                              class="dropdown-item blue cd-item cursor-pointer"
                              (click)="selectStatusFilter(statusOption)"
                          >
                            {{ statusOption | capitalizeWithSpaces }}
                          </div>
                        </li>
                      </ul>
                  </div> -->
                </th>
                <th scope="col">Latitude</th>
                <th scope="col">Longitude</th>
                <th scope="col" style="width: 200px">Address</th>
                <th scope="col" style="text-align: left !important; min-width: 200px">Description</th>
                <th scope="col">MAS Response</th>
            </tr>
        </thead>

        <tbody *ngIf="isLoading">
            <tr class="no-hover">
                <td colspan="8" class="text-center px-3">
                    <app-loading type="placeholder" [placeholderLength]="10"></app-loading>
                </td>
            </tr>
        </tbody>

        <tbody *ngIf="!isLoading && breadcrumbs && breadcrumbs.length > 0" class="break-word">
            <tr
                *ngFor="
                    let breadcrumb of breadcrumbs
                        | paginate: { id: 'breadcrumbsPagination', itemsPerPage: itemsPerPage, currentPage: pageNo, totalItems: totalItems };
                    let i = index
                "
            >
                <td>
                    {{ breadcrumb.id }}
                </td>
                <td>
                    {{ breadcrumb.created_at | date: 'MMM dd, yyyy' }}
                    <br />
                    {{ breadcrumb.created_at | date: 'hh:mm a' }}
                </td>
                <td class="mas-server-error">
                    {{ breadcrumb.status | capitalizeWithSpaces }}
                    <ng-container *ngIf="breadcrumb.is_broker_error == 1">
                        <div>
                            <app-message-popover messageTitle="Error Message" [messageDescription]="breadcrumb?.broker_error" [delay]="100">
                                <span class="text-danger fw-600">Error</span>
                            </app-message-popover>
                        </div>
                    </ng-container>
                </td>
                <td>
                    {{ breadcrumb.latitude }}
                </td>
                <td>
                    {{ breadcrumb.longitude }}
                </td>
                <td>
                    <ng-container *ngIf="addressMap.has(breadcrumb.id.toString())">
                        {{ addressMap.get(breadcrumb.id.toString()) }}
                    </ng-container>
                    <ng-container *ngIf="!addressMap.has(breadcrumb.id.toString()) && !loadingAddressMap.has(breadcrumb.id.toString())">
                        <button
                            class="btn-sm text-white btn btn-primary-color br-6 btn-primary fs-13"
                            (click)="getAddressFromLatLng(breadcrumb)"
                            [disabled]="!breadcrumb.latitude || !breadcrumb.longitude"
                        >
                            Fetch Address
                        </button>
                    </ng-container>
                    <div *ngIf="loadingAddressMap.has(breadcrumb.id.toString())" class="px-3 py-1 br-6 fw-600 fs-11 sticky-loading-box">
                        Fetching...
                    </div>
                </td>
                <td style="text-align: left !important">
                    {{ breadcrumb.description }}
                    <span
                        *ngIf="breadcrumb.broker_error_code && breadcrumb.broker_error"
                        [ngStyle]="{ color: breadcrumb.broker_error_code === '1000' ? '#00A86B' : '#FF0000' }"
                    >
                        <span *ngIf="breadcrumb?.description">|</span>
                        {{ breadcrumb.broker_error_code }} | {{ breadcrumb.broker_error }}
                    </span>
                </td>
                <td class="text-center text-capitalize">
                    {{ breadcrumb?.response_status || 'n/a' }}
                </td>
            </tr>
        </tbody>

        <tbody *ngIf="!isLoading && breadcrumbs && breadcrumbs.length == 0">
            <tr class="no-hover">
                <td colspan="8" class="text-center">No Data Found!</td>
            </tr>
        </tbody>
    </table>
</div>

<div class="custom_pagination_v2">
    <div class="d-flex flex-row-reverse align-items-center">
        <ng-container *ngIf="!isLoading">
            <div *ngIf="showPagination">
                <pagination-controls id="breadcrumbsPagination" responsive="true" (pageChange)="getBreadcrumbs($event)"></pagination-controls>
            </div>

            <div class="p-2 bd-highlight highlight ml-3 dropdown cursor-pointer">
                <div class="fw-600 fs-13 dropdown-toggle" data-toggle="dropdown" id="dropdown">
                    <span class="text-spacegrey">{{ utilityService.display_filter_label }}:</span>
                    <span class="text-blue-secondary ml-1">{{ itemsPerPage }}</span>
                </div>
                <div class="dropdown-menu cd-menu left-0 card-shadow" aria-labelledby="download" style="right: 0; left: -8px">
                    <div
                        *ngFor="let item of utilityService.display_filter_list"
                        class="dropdown-item text-center cd-item text-spacegrey"
                        (click)="getBreadcrumbs(1, item)"
                    >
                        {{ item }}
                    </div>
                </div>
            </div>

            <div class="text-spacegrey fs-13 fw-600">
                Results:
                <span class="text-blue-secondary">{{ totalItems }}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="isLoading">
            <app-loading type="placeholder" count="1" width="430px" height="24px"></app-loading>
        </ng-container>
    </div>
</div>
